import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppFabricationJobsPage.';
  public static readonly fabricationJobsTitle = `${Id.prefix}fabricationJobsTitle`;
  public static readonly fabricationJobsDescription = `${Id.prefix}fabricationJobsDescription`;
}

export class LangAppFabricationJobsPage {
  private constructor() {}
  public static fabricationJobsTitle(): string {
    return interpolate(Id.fabricationJobsTitle);
  }
  public static fabricationJobsDescription(): string {
    return interpolate(Id.fabricationJobsDescription);
  }
}

export class AppFabricationJobsPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.fabricationJobsTitle, 'Fabrication Jobs', 'Page title for fabrication jobs list');
    register.add(Id.fabricationJobsDescription, 'Fabrication jobs list', 'Page description for fabrication jobs list');
  }
}
